import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import AnnunciService from '../../services/AnnunciService';
import Button from '../../components/Button/Button';
import Spinner from '../../components/spinner/Spinner';
import ModaleAnnulla from '../../components/modaleAnnulla/ModaleAnnulla';
import {setAnnuncio, deleteAnnuncio} from '../../actions/IndexActions';
import Formatter from '../../utils/Formatter';

function AnnunciFamiglie(props) {
    const history = useHistory()
    const [annunci, setAnnunci] = useState([])
    const [showSpinner, setShowSpinner] = useState(false)
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice") || "{}")

    useEffect(() => { caricaAnnunci() }, [])

    function caricaAnnunci() {
        setShowSpinner(true)
        AnnunciService.getAnnunciByCodiceFiscale()
            .then(resp => setAnnunci(resp.data || []))
            .catch(err => console.error(err))
            .finally(() => setShowSpinner(false))
    }

    function nuovoAnnuncio() {
        props.deleteAnnuncio()
        history.push('/wizardAnnuncio')
    }

    function modificaAnnuncio(annuncio) {
        props.setAnnuncio(annuncio)
        history.push('/wizardAnnuncio')
    }

    function eliminaAnnuncio(id) {
        setShowSpinner(true)
        AnnunciService.eliminaAnnuncio(id)
            .then(() => caricaAnnunci())
            .catch(err => console.error(err))
            .finally(() => setShowSpinner(false))
    }

    return (
        <div className={"pt-4"} style={{marginLeft: "30px", marginRight: "30px"}}>
            <Spinner showSpinner={showSpinner}/>
            <div style={{marginBottom: "20px"}}>
                <h1 className={"h5"} style={{fontWeight: "bold"}}>I miei annunci</h1>
            </div>
            <Button typeButton={"Blue"} text={"Nuovo annuncio"} onClick={nuovoAnnuncio}
                    style={{height: "50px", width: "200px", marginBottom: "20px"}}/>
            <table className={"table table-hover mt-3"}>
                <thead>
                    <tr>
                        <th>N.</th><th>Data</th><th>Comune</th><th>Assistito</th>
                        <th>Assistente</th><th>Modifica</th><th>Elimina</th>
                    </tr>
                </thead>
                <tbody>
                    {annunci.map(a => (
                        <tr key={a.id}>
                            <td>{a.id}</td>
                            <td>{a.dataCreazione ? new Date(a.dataCreazione).toLocaleDateString('it-IT') : ""}</td>
                            <td>{comuniPerCodice[a.comune]?.descrizione || a.comune}</td>
                            <td>{Formatter.formatAssistito(a)}</td>
                            <td>{Formatter.formatAssistente(a)}</td>
                            <td><button type="button" style={{border: "none", background: "none", color: "#1b7ea9", cursor: "pointer", fontWeight: "bold", padding: "0", fontSize: "14px"}} onClick={() => modificaAnnuncio(a)}>Modifica</button></td>
                            <td>
                                <Button
                                    text={"Elimina"}
                                    style={{border: "none", background: "none", color: "#dc3545", cursor: "pointer", fontWeight: "bold", padding: "0", fontSize: "14px"}}
                                    dataToggle={"modal"}
                                    dataTarget={"modalEliminaAnnuncio" + a.id}
                                    dataBackdrop={"static"}
                                    dataKeyboard={false}
                                    header={"Attenzione!"}
                                    body={<ModaleAnnulla testo={"Attenzione! Sei sicuro di voler eliminare l'annuncio?"} testoConferma={"Elimina"} idAnnulla={"annulla" + a.id} idConferma={"elimina" + a.id} onClick={() => eliminaAnnuncio(a.id)}/>}
                                />
                            </td>
                        </tr>
                    ))}
                    {annunci.length === 0 && (
                        <tr><td colSpan={7}>Nessun annuncio presente</td></tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

const mapStateToProps = () => ({})
const mapDispatchToProps = (dispatch) => ({
    setAnnuncio: (a) => dispatch(setAnnuncio(a)),
    deleteAnnuncio: () => dispatch(deleteAnnuncio())
})
export default connect(mapStateToProps, mapDispatchToProps)(AnnunciFamiglie)
